import { render, staticRenderFns } from "./StatisticsRow.vue?vue&type=template&id=43567369&"
import script from "./StatisticsRow.vue?vue&type=script&lang=js&"
export * from "./StatisticsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43567369')) {
      api.createRecord('43567369', component.options)
    } else {
      api.reload('43567369', component.options)
    }
    module.hot.accept("./StatisticsRow.vue?vue&type=template&id=43567369&", function () {
      api.rerender('43567369', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/TouchpointOverview/Statistics/Page/StatisticsRow.vue"
export default component.exports